// Position Markers: Player circles with ID glow
import * as PIXI from 'pixi.js';
import { hexToPixi } from './colorUtils';

export function createPositionMarker(x: number, y: number, radius: number, color: string, glow: boolean = false) {
  const marker = new PIXI.Graphics();
  marker.circle(x, y, radius).fill({ color: hexToPixi(color), alpha: 0.7 });
  if (glow) {
    const glowCircle = new PIXI.Graphics();
    glowCircle.circle(x, y, radius * 1.7).fill({ color: hexToPixi(color), alpha: 0.18 });
    marker.addChild(glowCircle);
  }
  return marker;
}
